// ---------------------------------------
// Univerzalne shareovanie contentu do cez soc. siete 
// ---------------------------------------
var shareSocial = {
    idSharer: '#shareSocial_Btn',
    title: '',
    text: '',
    url: '',
    shareData: {},

    Init: function () {
        shareSocial.title = $('meta[property="og:title"]').attr('content') || 'TVN.sk';
        shareSocial.text = $('meta[property="og:description"]').attr('content') || '';
        shareSocial.url = window.location.href;
        shareSocial.shareData = {
            title: shareSocial.title,
            text: shareSocial.text,
            url: shareSocial.url
        };
        shareSocial.Check();
        shareSocial.DefEvents();
    },
    DefEvents: function () {
        $(document).on('click', shareSocial.idSharer, shareSocial.NativeSharerOpen);
    },
    Check: function () {
        try {
            if (navigator.share) {
                $('.share-box.share-native').attr('style', 'display: block !important');
                //console.log('Web Share API is supported - on load');
            } else {
                $('.share-box.share-buttons').attr('style', 'display: block !important');
                //console.log('Web Share API not supported - on load');
            }
        } catch (err) {
            $('.share-box.share-buttons').attr('style', 'display: block !important');
            //console.error('Error sharing:', err);
        }
    },
    NativeSharerOpen: function () {
        try {
            if (navigator.share) {
                navigator.share(shareSocial.shareData);
            } else {
                //console.log('Web Share API not supported. Sharebox for buttons was shown');
            }
        } catch (err) {
            //console.error('Error sharing:', err);
        }
    }
};
// module.exports = shareSocial;

export default shareSocial;